var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.63,
    height: 62.09,
    viewBox: "0 0 59.63 62.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.05,16.49c-.14-.58-.66-.98-1.25-.98H7.84c-.59,0-1.11.4-1.25.98C-1.22,47.72.08,40.76.08,47.83c0,.71.58,1.29,1.29,1.29h24.56v5.17h-5.17c-.59,0-1.11.4-1.25.98-1.39,5.55-1.58,5.62-1.06,6.28.56.71-.67.5,21.7.5.84,0,1.46-.79,1.25-1.61l-1.29-5.17c-.14-.58-.66-.98-1.25-.98h-5.17v-5.17h24.56c.71,0,1.29-.58,1.29-1.29,0-7.09,1.3-.12-6.5-31.34Zm-16.64,14.53l1.03,10.34h-16.53l1.03-10.34h14.47Zm-14.21-2.59l1.03-10.34h11.88l1.03,10.34h-13.95Zm17.84,12.93l-1.03-10.34h15.01l2.59,10.34h-16.57Zm13.33-12.93h-14.63l-1.03-10.34h13.08l2.59,10.34ZM8.85,18.1h11.78l-1.03,10.34H6.26l2.59-10.34Zm-3.23,12.93h13.72l-1.03,10.34H3.03l2.59-10.34Zm32.89,28.44h-17.37l.65-2.59h16.08l.65,2.59Zm-7.39-5.17h-2.59v-5.17h2.59v5.17Zm25.86-7.76H2.67v-2.59h54.3v2.59Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.47,6.69c-3.4-3.4-9.25-.11-7.31,1.83.5.5,1.32.5,1.83,0,.98-.98,2.68-.98,3.65,0,1.2,1.2,3.04-.62,1.83-1.83Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.33,4.86c3.03-3.03,7.94-3.03,10.97,0,1.21,1.21,3.04-.62,1.83-1.83-4.04-4.04-10.58-4.04-14.63,0-1.21,1.21.62,3.04,1.83,1.83Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.52,11.64c0,1.71,2.59,1.71,2.59,0s-2.59-1.71-2.59,0Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.296f9e55e53d2ee5058c4cd776585cab.svg";
export { ForwardRef as ReactComponent };